export const comments = (state) => state.comments
export const entityId = (state) => state.entityId
export const isLoadedComments = (state) => state.isLoadedComments
export const notificationsCount = (state) => state.notificationsCount
export const notifications = (state) => state.notifications
export const isFromNotif = (state) => state.isFromNotif
export const notifLink = (state) => state.notifLink
export const isLoadedEntityId = (state) => state.isLoadedEntityId



// WEBPACK FOOTER //
// ./src/store/modules/comments/getters.js